// Execute
document.addEventListener('DOMContentLoaded', function(){
    startApp();
})

function startApp(){
    createGallery();
}

// Create the Gallery
function createGallery(){
    const gallery = document.querySelector('.gallery__content');

    for(let i = 1; i <= 10;i++){
        const image = document.createElement('PICTURE');

        image.innerHTML = `
        <source srcset="build/img/review/gallery/small/${i}.avif" type="image/avif">
        <source srcset="build/img/review/gallery/small/${i}.webp" type="image/webp">

        <img loading="lazy" width="200" height="300" src="build/img/review/gallery/small/${i}.jpg" alt="Imagen galeria">
        `;
        image.onclick = function(){
            showImage(i);
        }

        image.classList.add('gallery__img')

        gallery.appendChild(image);
    }
}

// Show the modal window
function showImage(id){
    const image = document.createElement('PICTURE');

    image.innerHTML = `
    <source srcset="build/img/review/gallery/big/${id}.avif" type="image/avif">
    <source srcset="build/img/review/gallery/big/${id}.webp" type="image/webp">

    <img loading="lazy" width="200" height="300" src="build/img/review/gallery/big/${id}.jpg" alt="Imagen galeria">
    `;

    const overlay = document.createElement('DIV');
    overlay.appendChild(image);


    // Close the modal window when the user clicks anywhere
    overlay.onclick = function (){
        overlay.remove();

        const body = document.querySelector('body');
        body.classList.remove('fix-body');
    }

    const closeModal = document.createElement('P');
    closeModal.textContent = 'X';
    closeModal.classList.add('close-button');

    // Close the modal window when the user clicks in the X
    closeModal.onclick = function (){
        overlay.remove();

        const body = document.querySelector('body');
        body.classList.remove('fix-body');
    }

    overlay.classList.add('img-overlay');
    
    overlay.appendChild(closeModal)

    const body = document.querySelector('body');
    body.appendChild(overlay);
    body.classList.add('fix-body');
}

